var map = {
	"./DOMESO-RSP.jpg": 8405,
	"./Glujic-soap.png": 3772,
	"./ROOPAN-40.jpg": 2182,
	"./ROOPAN-DSR.jpg": 5231,
	"./RSP-MONTILEV.jpg": 3146,
	"./SWAS D-MR.jpg": 3102,
	"./SWAS D-SP.jpg": 7922,
	"./SWAS-A-SP.jpg": 876,
	"./SWAS-AP.jpg": 572,
	"./SWASGLIM-M1.jpg": 5000,
	"./SWASGLIM-M2.jpg": 5927,
	"./SWASMOL-650.jpg": 4036,
	"./SWASOM.jpg": 3044,
	"./SWASRAB-DSR.jpg": 3689,
	"./TELSWA-40.jpg": 3263,
	"./TELSWA-H.jpg": 7595,
	"./Tape L.jpg": 7410,
	"./Tape M.jpg": 7407,
	"./Tape XL.jpg": 5008,
	"./babify.jpeg": 2526,
	"./bumkins.jpg": 8685,
	"./ketoroob-soap.png": 503,
	"./kiah-organic-pads-XL+.jpg": 7190,
	"./kiah-organic-pads-XXL.jpg": 9025,
	"./klara.jpg": 6685,
	"./pant L.jpg": 5809,
	"./pant M.jpg": 7284,
	"./pant XL.jpg": 7205,
	"./sample.jpg": 9100,
	"./sanitary-pads-R.jpg": 3829,
	"./sanitary-pads-XL.jpg": 1723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8432;